/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import dateFormat from '@/tools/dateFormat';
import DownloadList from '../components/download-list.vue';

function handleEmpty(r, c, v) {
  return v || '-';
}
const statusMap = {
  0: '生成中',
  1: '生成中',
  2: '完成',
  3: '失败'
};
export default {
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  downloadName: {
    label: '文件名称',
    prop: 'downloadName',
    showToolTip: false,
    formatter: handleEmpty,
    render: function(h, ctx, r) {
      return (
        <span style="word-break:normal; overflow:unset">{r.downloadName}</span>
      );
    }
  },
  fileSize: {
    label: '文件大小',
    prop: 'fileSize',
    formatter: handleEmpty
  },
  status: {
    label: '文件生成进度',
    prop: 'status',
    formatter(r, c, v) {
      return statusMap[v] || '-';
    }
  },
  downloadDt: {
    label: '下载完成时间',
    prop: 'downloadDt',
    formatter(r, c, v) {
      return v ? dateFormat(v) : '-';
    }
  },
  operatorName: {
    label: '操作人姓名',
    prop: 'operatorName',
    formatter: handleEmpty
  },
  operation: {
    label: '操作',
    width: '120px',
    render: function(h, ctx, r, c) {
      const vm = ctx.parent;
      const { taskRecordUrls } = r;
      const btnDisabled =
        !taskRecordUrls ||
        !taskRecordUrls.length ||
        taskRecordUrls[0].urlStatus === 2;
      return (
        <div>
          <el-button
            type="text"
            disabled={btnDisabled}
            onClick={() => {
              if (btnDisabled) {
                vm.$message.error('无下载数据');
                return;
              }
              if (taskRecordUrls.length === 1) {
                vm.$downloadFile(
                  taskRecordUrls[0].downloadUrl,
                  true,
                  taskRecordUrls[0].downloadName
                );
                return;
              }
              if (taskRecordUrls.length > 1) {
                vm.$xrkDialog({
                  showConfirm: false,
                  showCancel: true,
                  cancelText: '关闭',
                  width: '700px',
                  title: '下载列表',
                  $slots: {
                    default: vm.$createElement(DownloadList, {
                      props: {
                        tableData: taskRecordUrls
                      }
                    })
                  }
                });
              }
            }}
          >
            下载
          </el-button>
        </div>
      );
    }
  }
};
